import BaseComponent from "../../../../baseComponent.js";
import ColorOptions from "./colorOptions.jsx";
import FontOptions from "./fontOptions.jsx";
import LengthOptions from "./lengthOptions.jsx";
import DecimalOptions from "./decimalOptions.jsx";
import TypeOptions from "./typeOptions.jsx";
import AlignOptions from "./alignOptions.jsx";
import SwitchOption from "./switchOption.jsx";
import CustomColor from "./customColor.jsx";
import GroupSeparatorOption from "./groupSeparatorOption.jsx";
import SuffixOption from "./suffixOption.jsx";
import FontSizeTypeOption from "./fontSizeTypeOption.jsx";

export default class StyleBox extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      color: "",
      fontFamily: "",
      multiplier: "",
      bold: false,
      type: this.props.type,
      suffix: ""
    }
  }

  componentDidMount() {
    this.shownOptions = null;
  }

  showOptions(optElement) {
    if ($(this.refs.styleBox).hasClass("inactive")) {
      $(this.shownOptions).hide();
      this.shownOptions = null;
    }
    if (this.shownOptions) {
      $(this.shownOptions).hide();

      if (this.shownOptions == optElement) {
        this.shownOptions = null;
        return;
      } else {
        this.shownOptions = null;
      }
    }

    $(optElement).show();
    this.shownOptions = optElement;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.selectionStyle == null) return false;
    return this.state.color !== nextProps.selectionStyle.color ||
      this.state.fontFamily !== nextProps.selectionStyle.fontFamily ||
      this.state.multiplier !== nextProps.selectionStyle.multiplier ||
      this.state.bold !== nextProps.selectionStyle.bold ||
      this.state.type !== nextProps.type ||
      this.state.fontSizeType !== nextProps.fontSizeType;
  }

  componentWillUpdate(nextProps, nextState) {
    this.setState({
      color: nextProps.selectionStyle.color,
      fontFamily: nextProps.selectionStyle.fontFamily,
      multiplier: nextProps.selectionStyle.multiplier,
      bold: nextProps.selectionStyle.bold,
      type: nextProps.type,
      fontSizeType: nextProps.fontSizeType
    })
  }

  onFontChange(style, value) {
    this.hideOption();
    this.props.onFontChange(style, value);
  }

  onLengthChange(length) {
    this.hideOption();
    this.props.onLengthChange(length);
  }

  onDecimalPlacesChange(length) {
    $(this.shownOptions).hide();
    this.shownOptions = null;
    this.props.onDecimalPlacesChange(length);
  }

  onDigitsChange(length) {
    this.hideOption();
    this.props.onDigitsChange(length);
  }

  onTypeChange(type) {
    this.hideOption();
    this.props.onTypeChange(type);
  }

  onFontSizeTypeChange(type) {
    this.hideOption();
    this.props.onFontSizeTypeChange(type);
  }

  onAlignChange(type) {
    this.hideOption();
    this.props.onAlignChange(type);
  }

  hideOption() {
    $(this.shownOptions).hide();
    this.shownOptions = null;
  }

  render() {
    return (
      <div className='tw-edit-box' ref="styleBox">
        <ColorOptions onOptionValueClick={this.props.onFontChange}/>
        <CustomColor color={this.state.color} onChange={this.props.onFontChange}/>
        <FontOptions onOptionValueClick={(s, v) => this.onFontChange(s, v)}
                     onOptionClick={(ele) => this.showOptions(ele)}
                     color={this.state.color} fontFamily={this.state.fontFamily}
                     fontSizeType={this.props.fontSizeType}
                     multiplier={this.state.multiplier} bold={this.state.bold}/>
        <FontSizeTypeOption onOptionValueClick={(type) => this.onFontSizeTypeChange(type)}
                            onOptionClick={(ele) => this.showOptions(ele)} type={this.props.fontSizeType}/>
        <TypeOptions onOptionValueClick={(type) => this.onTypeChange(type)}
                     onOptionClick={(ele) => this.showOptions(ele)} type={this.props.type}/>

        {this.state.type === 'String' ?
          <LengthOptions onOptionValueClick={(length) => this.onLengthChange(length)}
                         onOptionClick={(ele) => this.showOptions(ele)} textLength={this.props.textLength}/>
          :
          <DecimalOptions label="Decimal places" onOptionValueClick={(length) => this.onDecimalPlacesChange(length)}
                          min={0} max={10}
                          onOptionClick={(ele) => this.showOptions(ele)} decimalPlaces={this.props.decimalPlaces}/>
        }
        {
          this.state.type === 'Number' ?
            <DecimalOptions label="Digits" onOptionValueClick={(length) => this.onDigitsChange(length)}
                            min={1} max={10}
                            onOptionClick={(ele) => this.showOptions(ele)}
                            decimalPlaces={this.props.digits}/> : null
        }
        <AlignOptions onOptionValueClick={(type) => this.onAlignChange(type)}
                      onOptionClick={(ele) => this.showOptions(ele)} align={this.props.align}/>

        <SwitchOption label="Animation" value={this.props.animate} onChange={this.props.onAnimationChange}/>

        {
          this.state.type === 'Number' ?
            <GroupSeparatorOption value={this.props.groupSeparator}
                                  onChange={this.props.onGroupSeparatorChange}/> : null
        }
        <SuffixOption suffix={this.props.suffix} onSuffixChange={this.props.onSuffixChange}/>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/textual/style/styleBox.jsx